import { Component, ElementRef, OnInit, Renderer2, ViewChild, ComponentRef, Injector, ViewContainerRef, createComponent,ComponentFactoryResolver, ComponentFactory} from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { eContentType } from 'src/app/core/enums/eContentType';
import { eTypeMessage } from 'src/app/core/enums/eTypeMessage';

import { AwsLexService } from 'src/app/services/aws-lex.service';
import { environment } from 'src/environments/environment';

import { v4 as uuidv4 } from 'uuid'

import {ContactFormComponent} from './contact-form/contact-form.component'

import ESTADOS from 'src/assets/estados.json';

declare var $: any;

@Component({

  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  /**Logo para el bot. */
  LOGO_BOT: string = '';

  AVATAR_IMG: string = '';
  /**Mostrar o no el mensaje de bienvenida. */
  SHOW_MESSAGE: boolean = false;
  /**Bandera de la primera carga para el mensaje de bienvenida. */
  private FIRST_CHARGE: boolean = true;

  /**Index de la imagen en el slider. */
  private SLIDE_INDEX: number = 1;
  /**Numerador del slider en página actual. */
  private NUMBER_SLIDER: number = 1;
  /**Muestra u oculta el chat. */
  SHOW_CHAT: boolean = false;
  /**Permite o no el envío de mensajes personalizados por el usuario. */
  private SEND_MESSAGE: boolean = false;
  /**Indicador para finalizar las interacciones generales. */
  private FINISH_ACTIONS: boolean = false;
  /**Cantidad de apartados con botones a eliminar. */
  private POR_ELIMINAR: number = 0;
  /**Cantidad de divs de puntos suspensivos a eliminar. */
  private POR_ELIMINAR_DOTS: number = 0;
  /**Animación de "Escribiendo...". */
  DOTS_GIF: string = '';
  /**Variable que se encargará de mostrar las variaciones del tiempo. */
  HORA: string = '';
  /** */
  MENSAJE: string = '';
  /**Placeholder para el input. */
  PLACEHOLDER: string = 'Seleccione una opción...';
  /**Estatus del input. */
  DISABLED_INPUT: boolean = true;
  /**Estatus para el borrado del historial. */
  BORRA_HISTORIAL: boolean = false;
  /**Objeto para el envío de la respuesta del usuario. */
  // LEX_MESSAGE!: iMessageLex;

  FORM!: FormGroup;
  ELIMINAR_SALUDO: number = 0;
  ELIMINAR_DATOS_INICIALES: number = 0;
  SHOW_BUTTON: boolean = false;
  ALL_AGES: any = [];
  TIME: number = 2000;

  SETTINGS_CHATBOT!: any;
  LAST_BODY: any;
  INTENT: any;
  SLOT_TO_ELICIT: any;

  GIF_CONTROL_ID = 1;

  STARTER_VIEW: boolean = true;
  LANGUAGE_VIEW: boolean =  false;
  INCHAT_CONTENT: boolean =  false;
  userLang: any = 'es_419';

  CONFIRM_FORM_VALIDATOR: boolean =  false;
  CONFIRM_TONELAJE_VALIDATOR: boolean = false;
  CONFIRM_M3_VALIDATOR: boolean = false;
  CONFIRM_SELECTABLE_BUTTON_VALIDATOR: boolean = false;

  STEPPER_VALIDATOR: any = 0;

  DOTS_VALIDATOR: boolean = false;

  FORM_VALIDATOR: boolean = false;

  @ViewChild('botOrganon') MESSAGES!: ElementRef;

  botOrganon!: ViewContainerRef;
  applicationRef: any;

  estadoValue: any;
  nombreValue: any;
  emailValue: any;
  telefonoValue: any;
  ofrecerValue: any;
  stakeholderValue: any;
  puestoValue: any;
  tonelajeValue: any;
  m3Value: any;
  fileValue: any
  elementRef: any;

  estadoValidate: boolean = false;
  nombreValidate: boolean = false;
  emailValidate: boolean = false;
  telefonoValidate: boolean = false;
  ofrecerValidate: boolean = false;
  stakeholderValidate: boolean = false;
  puestoValidate: boolean = false;
  tonelajeValidate: boolean = false;
  m3Validate: boolean = false;
  fileValidate: boolean = false;

  selectedButtonsArray: any = [];
  selectedButtonsweightArray: any = [];
  b64File: any;
  b64FileName: any;

  constructor(private renderer: Renderer2, private window: Window, private readonly awsLexService: AwsLexService, private formBuilder: FormBuilder) {

  }

  async ngOnInit(): Promise<void> {
    this.LOGO_BOT = 'assets/avatars/Bot.png';

    await this.initChatbot();
  }

  showDivs(n: number, Slider: string): void {
    let x = document.getElementsByClassName(Slider);
    if (x.length > 0) {
        if (n > x.length) {
            this.SLIDE_INDEX = 1;
        }
        if (n < 1) {
            this.SLIDE_INDEX = x.length;
        }
        for (let i: number = 0; i < x.length; i++) {
            x[i].setAttribute('style', 'display: none');
        }
        x[this.SLIDE_INDEX - 1].setAttribute('style', 'display: block');
    }
}

  scrollDown(): void {
    this.showDivs(1, 'mySlides' + this.NUMBER_SLIDER);
    this.NUMBER_SLIDER++;
    setTimeout(() => {
        let objDiv = document.getElementById('botOrganon') as HTMLElement;
        objDiv.scrollTop = objDiv.scrollHeight;
    }, 500);
}



  autoHiddeMessaje(): void {
    setTimeout(() => {
        this.SHOW_MESSAGE = false;
    }, 5000);
  }

  verifyUUID(): string {
    const _token = localStorage.getItem('Token');

    if (_token === null) {
        let _token: string = uuidv4();
        let _cleanToken = _token.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
        localStorage.setItem('Token', _cleanToken);
        return _cleanToken;
    } else {
        return _token;
    }
  }

  async initChatbot() {

    localStorage.clear();
    const _token = this.verifyUUID();

    this.SETTINGS_CHATBOT = {
        text: 'hola',
        sessionId: _token,
        session_state: {
            intent: {
              name: 'CM-mkt-welcome',
              state: 'InProgress',
              confirmationState: 'None',
            }
        }
    };

    const _result = (await this.awsLexService.sendLex2(this.SETTINGS_CHATBOT)) as any;

    //const jsonBody = JSON.parse(_result.body);
    //this.LAST_BODY = jsonBody;

    this.LAST_BODY = _result.body

    this.SETTINGS_CHATBOT.session_state = this.LAST_BODY.sessionState;

    this.createMessage();
  }

  reassignBodySessionState(NewBody: any) {
    //const jsonNewBody = JSON.parse(NewBody)

    this.LAST_BODY = NewBody;
    this.SETTINGS_CHATBOT.session_state = this.LAST_BODY.sessionState;
  }

  createHora(): void {
    let _div = this.renderer.createElement('div');
    this.renderer.addClass(_div, 'hora');
    const _dateNow = new Date(Date.now());
    const _horaActual = `${_dateNow.getHours().toString().padStart(2, '0')}:${_dateNow.getMinutes().toString().padStart(2, '0')}`;
    const _hora = this.renderer.createText(_horaActual);
    if (this.HORA === '' || this.HORA !== _hora.data) {
        this.renderer.appendChild(_div, _hora);
        this.renderer.appendChild(this.MESSAGES.nativeElement, _div);
        this.HORA = _hora.data;
    }
  }

  createMessageGif(): void {

    this.POR_ELIMINAR_DOTS = 1;

    this.DOTS_GIF = 'assets/icons/dots.gif';
    let _div = this.renderer.createElement('div');

    this.renderer.addClass(_div, 'question');
    this.renderer.setAttribute(_div,'id','gifId-'+this.GIF_CONTROL_ID);

    let _dots = this.renderer.createElement('img');
    this.renderer.setProperty(_dots, 'src', this.DOTS_GIF);
    this.renderer.addClass(_dots, 'dotsGif');
    this.renderer.setProperty(_dots, 'loading', 'lazy');
    this.renderer.appendChild(_div, _dots);

    this.renderer.addClass(_div, 'gif');
    let _uniqueImg = this.renderer.createElement('img');
    this.renderer.setProperty(_uniqueImg, 'src', this.LOGO_BOT);
    this.renderer.addClass(_uniqueImg, 'botMessage');
    this.renderer.setProperty(_uniqueImg, 'loading', 'lazy');
    this.renderer.appendChild(_div, _uniqueImg);
    this.renderer.appendChild(this.MESSAGES.nativeElement, _div);

    this.scrollDown();
    this.GIF_CONTROL_ID += 1;
  }

  removePlaceholderDotsElements(): void {
    for (let i = 0; i < this.POR_ELIMINAR_DOTS; i++) {
        const placeholder1 = this.MESSAGES.nativeElement.querySelector('.gif');
        if (placeholder1 !== null) {
            this.renderer.removeChild(this.MESSAGES.nativeElement, placeholder1);
        }
    }
  }

  removePlaceholderDotsElementsById(){
    console.log('GIF CONTROL ID: ',this.GIF_CONTROL_ID)

    const idToRemove = this.GIF_CONTROL_ID - 1;
    console.log(this.MESSAGES )
    if(this.MESSAGES.nativeElement.children.length > 2){
      this.renderer.setStyle(this.MESSAGES.nativeElement.querySelector('#gifId-'+idToRemove),'display','none');
    }

    //this.renderer.setStyle(this.MESSAGES.nativeElement.querySelector('#gifId-'+this.GIF_CONTROL_ID),'display','none');

  }


  createButtons(Buttons: any[], type?:string): void {
    // const _interaccionBot: iHistory = {
    //     type: eTypeMessage.AnswerUser,
    //     Content: {
    //         message: Buttons,
    //     },
    // };
    // this.guardarEnHistorial(_interaccionBot);

    let _div = this.renderer.createElement('div');
    this.renderer.addClass(_div, 'text-right');
    Buttons.forEach((btn) => {
        const _button = this.renderer.createElement('button');
        this.renderer.addClass(_button, 'eliminar');
        const _buttonText = this.renderer.createText(btn.text);
        this.renderer.appendChild(_button, _buttonText);
        this.renderer.appendChild(_div, _button);
        this.renderer.listen(_button, 'click', () => {
            this.createComponentsAnswerUser(`${btn.text}`, `${btn.value}`,type);
        });
    });
    this.renderer.appendChild(this.MESSAGES.nativeElement, _div);
  }

  removePlaceholderElements(): void {
    console.log(this.POR_ELIMINAR);
    console.log(this.POR_ELIMINAR, ' IN REMOVEPLACEHOLDER ELEMENTS')
    for (let i = 0; i < this.POR_ELIMINAR; i++) {
        const placeholder1 = this.MESSAGES.nativeElement.querySelector('.text-right');
        if (placeholder1 !== null) {
            this.renderer.removeChild(this.MESSAGES.nativeElement, placeholder1);
        }
    }
  }

  separateTextModelDescription(Element: any, Text: any): void {
    console.log(Element);
    let _separated = Text.split('\n');
    for (let i = 0; i < _separated.length; i++) {
        let _text = this.renderer.createText(_separated[i]);
        this.renderer.appendChild(Element, _text);
        const _subSplit = _separated.length > i + 1 ? _separated[i + 1].split('') : [];
        if (_subSplit.length > 0 && _subSplit[0] !== ' ') {
            let _p = this.renderer.createElement('br');
            this.renderer.appendChild(Element, _p);
        }
    }
  }

  async createMessage() {
    // this.PLACEHOLDER = 'Seleccione una opción...';
    this.createHora();
    let _div = this.renderer.createElement('div');
    // if (Response.responseCard !== undefined && Response.responseCard.genericAttachments[0].imageUrl !== undefined) {
    //     this.showImages(_div, Response.responseCard.genericAttachments);
    // }

    // const _interaccionBot: iHistory = {
    //     type: Response.responseCard && Response.responseCard.genericAttachments[0].imageUrl ? eTypeMessage.Galery : eTypeMessage.Server,
    //     Content: {
    //         message: Response.message,
    //         galery: Response.responseCard ? Response.responseCard.genericAttachments : undefined,
    //     },
    // };

    // this.guardarEnHistorial(_interaccionBot);
    const _contentBody = this.LAST_BODY.messages as any;
    const _messages = _contentBody.filter((x: { contentType: eContentType; }) => x.contentType === eContentType.PlainText);

    const _buttons = _contentBody.filter((x: { contentType: eContentType; }) => x.contentType === eContentType.ImageResponseCard);

    console.log(_messages)
    console.log(_buttons)

    this.INTENT = this.SETTINGS_CHATBOT.session_state.intent.name;
    this.SLOT_TO_ELICIT = this.SETTINGS_CHATBOT.session_state.dialogAction.slotToElicit;

    console.log("messages.length > 1: ", _messages.length > 1, "| messages.length = ", _messages.length)
    if (_messages.length > 1) {


      console.log("----------------------------------------------------IF DE _messages.length > 1--------------------------------------------------------------------")

      console.log("INTENT")
      console.log(this.INTENT)

      console.log("SLOTTOELICIT")
      console.log(this.SLOT_TO_ELICIT)

        for (let i: number = 0; i < _messages.length; i++) {
            setTimeout(
                () => {
                    this.removePlaceholderDotsElements();
                    let _div = this.renderer.createElement('div');
                    this.separateTextModelDescription(_div, _messages[i].content);
                    this.renderer.addClass(_div, 'question');
                    let _uniqueImg = this.renderer.createElement('img');
                    this.renderer.setProperty(_uniqueImg, 'src', this.LOGO_BOT);
                    this.renderer.addClass(_uniqueImg, 'botMessage');
                    this.renderer.setProperty(_uniqueImg, 'loading', 'lazy');
                    this.renderer.appendChild(_div, _uniqueImg);
                    this.renderer.appendChild(this.MESSAGES.nativeElement, _div);

                    this.createMessageGif(); //aqui es el mero

                    console.log("_messages.length - 1 === i && _buttons.length > 0: ", _messages.length - 1 === i && _buttons.length > 0)
                    if (_messages.length - 1 === i && _buttons.length > 0) {

                      this.removePlaceholderDotsElementsById();

                        if (_buttons.length == 1) {
                        //_buttons[0].imageResponseCard?.buttons.push({text:'Regresar',value:'regreso'}); //Back button to methods in conversation
                          for (const _button of _buttons) {
                              let aux_por_eliminar = this.POR_ELIMINAR;
                              console.log('POR ELIMINAR ANTES DE LA ASIGNACION: ', this.POR_ELIMINAR)
                              this.POR_ELIMINAR += _button.imageResponseCard !== undefined ? _button.imageResponseCard?.buttons?.length : 0;

                              if(_button.imageResponseCard?.buttons){

                                console.log('EXISTEEEEEN BOTONES, DEBE SER TRUE')
                                console.log(this.POR_ELIMINAR);
                                _button.imageResponseCard !== undefined ? this.createButtons(_button.imageResponseCard?.buttons) : [];
                              }else{
                                console.log('MOSTAR INFOGRAFIA Y GENERAR FORMULARIO')
                                this.POR_ELIMINAR = aux_por_eliminar;
                                console.log(this.POR_ELIMINAR);
                                window.open(_button.imageResponseCard.imageUrl, '_blank');
                                this.createFormComponent(this.INTENT)
                              }


                          }

                        }else{

                          const auxButtonsArray: any = _buttons;
                          const multipleArraybuttons: any = []
                          const finalButtonsArray: any = [];
                          const auxImageArray: any = [];
                          for (let i = 0; i < auxButtonsArray.length; i++) {
                            multipleArraybuttons.push(auxButtonsArray[i].imageResponseCard.buttons)
                          }
                          for (let i = 0; i < multipleArraybuttons.length; i++) {
                            if(typeof multipleArraybuttons[i] != 'undefined'){
                              for (let j = 0; j < multipleArraybuttons[i].length; j++) {
                                finalButtonsArray.push(multipleArraybuttons[i][j])
                              }
                            }else{
                              this.removePlaceholderDotsElementsById();
                              //auxImageArray.push(auxButtonsArray[0].imageResponseCard)
                              //this.showImages(_div, auxImageArray);


                              console.log(auxButtonsArray)

                              window.open(auxButtonsArray[0].imageResponseCard.imageUrl, '_blank');
                            }
                          }
                            this.POR_ELIMINAR += finalButtonsArray.length;

                            this.createButtons(finalButtonsArray);

                        }

                        //this.removePlaceholderDotsElements();
                    }else{

                    }
                    console.log(_messages.length - 1, i, _messages == i)
                    if(_messages.length - 1 == i){
                      this.removePlaceholderDotsElementsById();
                      if(this.SLOT_TO_ELICIT == 'region'){
                        console.log("aqui agregar el form 1")
                        this.createFormComponent(this.INTENT)
                      }

                    }

                    //this.removePlaceholderDotsElements();
                },
                i > 0 ? this.TIME * i : 0
            );
        }

    } else {

      console.log("----------------------------------------------------ELSE DE _messages.length > 1--------------------------------------------------------------------")

      console.log("INTENT")
      console.log(this.INTENT)

      console.log("SLOTTOELICIT")
      console.log(this.SLOT_TO_ELICIT)

      console.log("lastBody")
      console.log(this.LAST_BODY)

      console.log("settingsChatbot")
      console.log(this.SETTINGS_CHATBOT)


        //this.removePlaceholderDotsElementsById();

        this.separateTextModelDescription(_div, _messages[0].content);
        this.renderer.addClass(_div, 'question');
        let _uniqueImg = this.renderer.createElement('img');
        this.renderer.setProperty(_uniqueImg, 'src', this.LOGO_BOT);
        this.renderer.addClass(_uniqueImg, 'botMessage');
        this.renderer.setProperty(_uniqueImg, 'loading', 'lazy');
        this.renderer.appendChild(_div, _uniqueImg);
        this.renderer.appendChild(this.MESSAGES.nativeElement, _div);


        console.log("_buttons.length > 0: ", _buttons.length > 1, "| _buttons.length = ", _buttons.length)
        if (_buttons.length > 0) {

          console.log("_buttons.length == 1: ", _buttons.length == 1, "| _buttons.length = ", _buttons.length)
            if (_buttons.length == 1) {

              console.log('---------------------------------------------AQUI 1-------------------------------------------------');

                  //this.removePlaceholderDotsElements();
                  //console.log(this.SLOT_TO_ELICIT)

                  if(this.SLOT_TO_ELICIT != 'puntos-venta'){
                    this.removePlaceholderDotsElementsById();
                  }


                    for (const _button of _buttons) {
                      if(this.SLOT_TO_ELICIT == 'otros-productos'){
                        this.POR_ELIMINAR += _button.imageResponseCard !== undefined ? _button.imageResponseCard?.buttons.length : 0;
                        _button.imageResponseCard !== undefined ? this.createSelectableButtons(_button.imageResponseCard?.buttons) : [];
                      }else{
                        this.POR_ELIMINAR += _button.imageResponseCard !== undefined ? _button.imageResponseCard?.buttons.length : 0;
                        _button.imageResponseCard !== undefined ? this.createButtons(_button.imageResponseCard?.buttons) : [];
                      }

                  }


            }else{

              console.log('---------------------------------------------AQUI 2-------------------------------------------------');

              //.removePlaceholderDotsElements();
              this.removePlaceholderDotsElementsById();

              const auxButtonsArray: any = _buttons;
              const multipleArraybuttons: any = []
              const finalButtonsArray: any = [];
              const auxImageArray: any = [];
              for (let i = 0; i < auxButtonsArray.length; i++) {
                multipleArraybuttons.push(auxButtonsArray[i].imageResponseCard.buttons)
              }
              for (let i = 0; i < multipleArraybuttons.length; i++) {
                if(typeof multipleArraybuttons[i] != 'undefined'){
                  for (let j = 0; j < multipleArraybuttons[i].length; j++) {
                    finalButtonsArray.push(multipleArraybuttons[i][j])
                  }
                }else{
                  //auxImageArray.push(auxButtonsArray[1].imageResponseCard)
                  //this.showImages(_div, auxImageArray);

                  window.open(auxButtonsArray[1].imageResponseCard.imageUrl, '_blank');
                }
              }
                this.POR_ELIMINAR += finalButtonsArray.length;

                this.createButtons(finalButtonsArray);

            }

        }else{
          console.log("-----------------------------------------------------------------AQUI URGE METER ALGO!!!!!!!!!!!!!!!!!!!!-----------------------------------------------------------------------")
          this.removePlaceholderDotsElementsById()
          if(this.SLOT_TO_ELICIT == 'tonelaje-otro'){

            console.log(this.LAST_BODY.sessionState.intent.slots.comprar.value.originalValue == 'concreto')
            if(this.LAST_BODY.sessionState.intent.slots.comprar.value.originalValue == 'concreto'){
              console.log("AQUIIIIIIIIIIIIIIIIIIIIIIIIIII EN CONCRTO M3")
              this.CONFIRM_M3_VALIDATOR = true;
              this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('m3'))
            }else{
              this.CONFIRM_TONELAJE_VALIDATOR = true;
              this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('tonelaje'))
            }

          }
          if(this.SLOT_TO_ELICIT == 'region'){
            console.log("aqui agregar el form 2")

            this.createFormComponent(this.INTENT)
          }

        }



    }

    // // this.separateTextModelDescription(_div, this.LAST_BODY.messages[0].content);
    // this.renderer.addClass(_div, 'question');
    // let _uniqueImg = this.renderer.createElement('img');
    // this.renderer.setProperty(_uniqueImg, 'src', this.LOGO_BOT);
    // this.renderer.addClass(_uniqueImg, 'botMessage');
    // this.renderer.setProperty(_uniqueImg, 'loading', 'lazy');
    // this.renderer.appendChild(_div, _uniqueImg);
    // this.renderer.appendChild(this.MESSAGES.nativeElement, _div);
    // // this.POR_ELIMINAR = this.LAST_BODY.messages[1].imageResponseCard.buttons.length;
    // // this.createButtons(this.LAST_BODY.messages[1].imageResponseCard.buttons);

    // if (_buttons.length > 0) {
    //     for (const _button of _buttons) {
    //         this.POR_ELIMINAR += _button.imageResponseCard !== undefined ? _button.imageResponseCard?.buttons.length : 0;
    //         const _arrayButtons = _button.imageResponseCard !== undefined ? this.createButtons(_button.imageResponseCard?.buttons) : [];
    //     }
    // }

    // if (Response.dialogState !== 'Fulfilled') {
    //     if (Response.responseCard !== undefined) {
    //         this.SEND_MESSAGE = false;
    //         this.POR_ELIMINAR = Response.responseCard.genericAttachments.length;
    //         if (Response.responseCard.genericAttachments[0].imageUrl && Response.responseCard.genericAttachments[0].buttons !== undefined) {
    //             this.createButtons(Response.responseCard.genericAttachments[0].buttons);
    //         } else {
    //             const _buttons: any[] = [];
    //             Response.responseCard.genericAttachments.forEach((_btn: any) => {
    //                 _buttons.push(..._btn.buttons);
    //             });
    //             this.createButtons(_buttons);
    //         }
    //     } else {
    //         this.SEND_MESSAGE = true;
    //     }
    // } else {
    //     this.FINISH_ACTIONS = true;
    //     this.SEND_MESSAGE = false;
    //     this.scrollDown();
    //     return;
    // }

    // this.PLACEHOLDER = this.SEND_MESSAGE ? 'Escriba aquí...' : 'Seleccione una opción...';
    // this.DISABLED_INPUT = !this.SEND_MESSAGE;
    this.scrollDown();
    //this.enableHeaderMenuButtons() //NOT HERE
  }

  creaRespuestaUsuario(Text: string): void {

    let _div = this.renderer.createElement('div');
    this.renderer.addClass(_div, 'botonesRespuesta');
    let _uniqueImg = this.renderer.createElement('img');
    const _button = this.renderer.createElement('button');
    this.renderer.addClass(_button, 'respuesta');
    const _buttonText = this.renderer.createText(Text);

    this.renderer.appendChild(_div,_uniqueImg);
    this.renderer.appendChild(_button, _buttonText);
    this.renderer.appendChild(_div, _button);
    this.renderer.appendChild(this.MESSAGES.nativeElement, _div);

  }

  async sendUserResponse(Response: string): Promise<any> {

    let _result;
    if (Response === 'init' && localStorage.getItem('SessionAttributes') === null) {
        // /**Se generan los session attributes iniciales. */
        // const _localAttributes: any = {
        //     site_origin: document.referrer,
        //     domain: document.referrer !== '' ? new URL(document.referrer).host : this.window.location.host,
        // };
        // /**Se obtienen los session attributes existentes en el local storage. */
        // const _getSessionAttributes: any = localStorage.getItem('SessionAttributes');
        // const _createSessionAttributes = _getSessionAttributes !== null ? JSON.parse(localStorage.getItem('SessionAttributes') as string) : _localAttributes;
        // let stuff: { [key: string]: string } = {};
        // Object.keys(_createSessionAttributes).forEach((key) => {
        //     stuff[`${key}`] = _createSessionAttributes[key];
        // });
        /**Se genera el objeto con los parámetros necesarios. */
        // this.LEX_MESSAGE = {
        //     bot_alias: environment.BOT_ALIAS,
        //     bot_name: environment.BOT_NAME,
        //     inputText: Response,
        //     user_id: localStorage.getItem('Token') as string,
        //     sessionAttributes: stuff,
        //     requestAttributes: {},
        // };
        this.SETTINGS_CHATBOT.text = Response;

        // const _result = (await this.awsLexService.sendLexData(this.LEX_MESSAGE)) as any;
        _result = (await this.awsLexService.sendLex2(this.SETTINGS_CHATBOT)) as any;
        this.LAST_BODY = _result.body;
        this.SETTINGS_CHATBOT.session_state = this.LAST_BODY.sessionState;
        // _resp = JSON.parse(_result.body);

        // /**Se obtienen los session attributes de respuesta. */
        // const _sessionAttributes: any = _resp.sessionAttributes;
        // /**Se convierten a string los session attributes actuales. */
        // const _init: boolean = Response === 'init';
        // const _newSessionAttributes = _init ? _sessionAttributes : JSON.parse(_sessionAttributes);
        // /**Se almacenan los session attributes en el local storage. */
        // localStorage.setItem('SessionAttributes', JSON.stringify(_newSessionAttributes, null, 2));
    } else {
        // const _localAttributes: any = {
        //     site_origin: document.referrer,
        //     domain: document.referrer !== '' ? new URL(document.referrer).host : this.window.location.host,
        //     // site_origin: this.window.location.href,
        //     // domain: this.window.location.host,
        //     // domain: 'www.google.com',
        // };
        // const _getSessionAttributes: any = localStorage.getItem('SessionAttributes');
        // const _createSessionAttributes = _getSessionAttributes !== null ? JSON.parse(localStorage.getItem('SessionAttributes') as string) : _localAttributes;
        // let stuff: { [key: string]: string } = {};
        // Object.keys(_createSessionAttributes).forEach((key) => {
        //     stuff[`${key}`] = _createSessionAttributes[key];
        // });
        // this.LEX_MESSAGE = {
        //     bot_alias: environment.BOT_ALIAS,
        //     bot_name: environment.BOT_NAME,
        //     inputText: Response,
        //     user_id: localStorage.getItem('Token') as string,
        //     sessionAttributes: stuff,
        //     requestAttributes: {},
        // };
        // const _result = (await this.awsLexService.sendLexData(this.LEX_MESSAGE)) as any;
        // _resp = JSON.parse(_result.body);
        // _resp.sessionAttributes.key_validation_show_models = _resp.sessionAttributes.key_validation_show_models ?? 'SHOW_MODELS';
        // localStorage.setItem('SessionAttributes', JSON.stringify(_resp.sessionAttributes, null, 2));

        this.SETTINGS_CHATBOT.text = Response;

        // const _result = (await this.awsLexService.sendLexData(this.LEX_MESSAGE)) as any;
        _result = (await this.awsLexService.sendLex2(this.SETTINGS_CHATBOT)) as any;
        this.LAST_BODY = _result.body;
        this.SETTINGS_CHATBOT.session_state = this.LAST_BODY.sessionState;
    }

    return _result;
  }

  async createComponentsAnswerUser(Text: string, Answer: string, type?:string): Promise<void> {
    console.log(Text,Answer, type);

    console.log("AQUI SE REALIZA LA FUNCIONALIDAD DEL BOTON PARA MANDAR EL DATO")



    // if (this.FINISH_ACTIONS) {
    //     alert('Debe reiniciar la búsqueda para interactuar nuevamente.');
    //     return;
    // }
    if(type == 'confirm'){
      if(Answer == 'si'){
        this.changeFormValidationStatus(false);
        let MESSAGESelementArray = this.MESSAGES.nativeElement.children;
        for (let i = 0; i < this.MESSAGES.nativeElement.children.length; i++) {
          if(MESSAGESelementArray[i].id == 'FORMID'){
            this.renderer.removeChild(this.MESSAGES.nativeElement, this.MESSAGES.nativeElement.children[i]);
          }

        }
        let formDataArray = await this.getFormData(type);
        console.log('aqui se crea la respuesta del usuario confirmacion')
        this.removePlaceholderElements();
        this.creaRespuestaUsuario(Text);
        this.createMessageGif();

        for (let i = 0; i < formDataArray.length; i++) {
          console.log(i)
          const _response = await this.sendUserResponse(formDataArray[i])
          this.reassignBodySessionState(_response.body)
          if(i == formDataArray.length-1){
            if(this.SETTINGS_CHATBOT.session_state.dialogAction.slotToElicit == 'attachment'){
              console.log('aquiiiiii subir archivooooooo')
              let _result;
              _result = (await this.awsLexService.uploadFile(this.b64FileName,this.SETTINGS_CHATBOT.sessionId,this.b64File)) as any;
              const _response = await this.sendUserResponse(this.SETTINGS_CHATBOT.sessionId+'/'+this.b64FileName)
              this.reassignBodySessionState(_response.body)
              this.removePlaceholderDotsElementsById();
            }
            this.removePlaceholderDotsElements();
            this.createMessage();
          }
        }

      }else if(Answer == 'no'){
        this.changeFormValidationStatus(false);
        let MESSAGESelementArray = this.MESSAGES.nativeElement.children;
        for (let i = 0; i < this.MESSAGES.nativeElement.children.length; i++) {
          if(MESSAGESelementArray[i].id == 'FORMID'){
            this.renderer.removeChild(this.MESSAGES.nativeElement, this.MESSAGES.nativeElement.children[i]);
          }

        }
        console.log(this.MESSAGES.nativeElement.children[10].id);
        console.log('reiniciar formulario');
        this.removePlaceholderElements();
        this.creaRespuestaUsuario(Text);
        this.createMessageGif();
        this.createStaticBotInteractionMessage('Escribe la informacion solicitada a continuacion:');
        console.log("aqui agregar el form 3")
        this.createFormComponent(this.INTENT);

        this.removePlaceholderDotsElements();
        this.removePlaceholderDotsElementsById();

      }
    }else if(type == 'tonelaje' || type == 'm3'){
      this.removePlaceholderElements();
      this.createMessageGif();
      const _response = await this.sendUserResponse(Answer);
      this.reassignBodySessionState(_response.body);
      this.removePlaceholderDotsElements();
      this.createMessage();
    }else if(type=='distribuidor'){

      for (let i = 0; i < 2; i++) {
        console.log('ultimo for')
        console.log(i)
        if(i >= 1){
          const _response = await this.sendUserResponse(this.selectedButtonsweightArray.toString())
          this.reassignBodySessionState(_response.body)
          this.removePlaceholderDotsElements();
          this.createMessage();
          break;
        }
        const _response = await this.sendUserResponse(this.selectedButtonsArray.toString())
        this.reassignBodySessionState(_response.body)
      }
      this.selectedButtonsweightArray = [];
      this.selectedButtonsArray = [];
      this.STEPPER_VALIDATOR = 0;
    }else{
      this.removePlaceholderElements();
      this.creaRespuestaUsuario(Text);
      this.createMessageGif();
      const _response = await this.sendUserResponse(Answer);
      this.reassignBodySessionState(_response.body);
      this.removePlaceholderDotsElements();
      this.createMessage();
    }

  }

  async createFormComponent(intent: any){
    this.CONFIRM_FORM_VALIDATOR = true;

    switch (intent) {
      case 'CM-mkt-comprar':

        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createStateSelectElement());
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('nombre'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('correo'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('telefono'));

        break;

      case 'CM-mkt-distribuidor':
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createStateSelectElement());
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('nombre'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('correo'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('telefono'));

        break;

      case 'CM-mkt-asesoria':
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('nombre'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('correo'));


        break;

      case 'CM-mkt-ofrecer':
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createStateSelectElement());
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('nombre'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('correo'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('telefono'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('ofrecer'));

        break;

      case 'CM-mkt-stakeholder':
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createStateSelectElement());
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('nombre'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('correo'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('telefono'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('stakeholder'));
        break;

      case 'CM-mkt-trabajar':
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createStateSelectElement());
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('nombre'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('correo'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('telefono'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputElement('puesto'));
        this.renderer.appendChild(this.MESSAGES.nativeElement, await this.createInputFileElement());

        break;
    }

  }

  async createStateSelectElement(){

    let div = this.renderer.createElement('div');
    this.renderer.addClass(div, 'botonesRespuesta');
    this.renderer.setAttribute(div, 'id', 'FORMID');

    let button = this.renderer.createElement('button');
    this.renderer.addClass(button, 'respuesta-gray');

    let select = this.renderer.createElement('select');
    this.renderer.listen(select,'change', (event) =>{
      this.validateForm('estado',event.target.value)
    })
    this.renderer.setAttribute(select, 'id', 'selectRegionId');
    this.renderer.addClass(select, 'regionSelect')

    let option = this.renderer.createElement('option');
    let optionText = this.renderer.createText('Estado/Región')

    this.renderer.appendChild(option,optionText);
    this.renderer.appendChild(select,option);

    for (let i = 0; i < ESTADOS.length; i++) {

      option = this.renderer.createElement('option');
      optionText = this.renderer.createText(ESTADOS[i].nombre);
      this.renderer.setAttribute(option, 'value', ESTADOS[i].nombre);

      this.renderer.appendChild(option,optionText);
      this.renderer.appendChild(select,option);
    }

    this.renderer.appendChild(div,button)
    this.renderer.appendChild(button,select);


    return div;
  }

  async createInputElement(type?:string){

    let div = this.renderer.createElement('div');
    this.renderer.addClass(div, 'botonesRespuesta');
    console.log(type != 'tonelaje' || 'm3' ? true : false, 'type', type)
    if(type == 'tonelaje' || type == 'm3'){
      this.renderer.setAttribute(div, 'id', 'FORMWEIGHTID');
    }else{
      this.renderer.setAttribute(div, 'id', 'FORMID');
    }


    let button = this.renderer.createElement('button');
    this.renderer.addClass(button, 'respuesta-gray');

    let input = this.renderer.createElement('input');
    this.renderer.listen(input,'change', (event) =>{
      this.validateForm(type,event.target.value)
    })

    this.renderer.addClass(input, 'contactInput')

    switch (type) {
      case 'nombre':
        this.renderer.setAttribute(input, 'id', 'inputNombreId');
        this.renderer.setAttribute(input,'placeholder','Nombre completo')
        this.renderer.setAttribute(input,'type','text');
        this.renderer.setAttribute(input,'minlength','5');
        this.renderer.setAttribute(input,'maxlength','33');
        break;

      case 'correo':
        this.renderer.setAttribute(input, 'id', 'inputCorreoId');
        this.renderer.setAttribute(input,'placeholder','Correo electrónico')
        this.renderer.setAttribute(input,'type','email');
        this.renderer.setAttribute(input,'minlength','5');
        this.renderer.setAttribute(input,'maxlength','33');
        break;

      case 'telefono':
        this.renderer.setAttribute(input, 'id', 'inputTelefonoId');
        this.renderer.setAttribute(input,'placeholder','Teléfono')
        this.renderer.setAttribute(input,'type','number');
        this.renderer.setAttribute(input,'onKeyPress','if(this.value.length==10) return false;');
        break;

      case 'ofrecer':
        this.renderer.setAttribute(input, 'id', 'inputOfrecerId');
        this.renderer.setAttribute(input,'placeholder','Detallar el servicio y/o productos que ofrecer')
        this.renderer.setAttribute(input,'type','text');
        this.renderer.setAttribute(input,'minlength','5');
        this.renderer.setAttribute(input,'maxlength','80');
        break;

      case 'stakeholder':
        this.renderer.setAttribute(input, 'id', 'inputStakeholderId');
        this.renderer.setAttribute(input,'placeholder','Detalle su solicitud')
        this.renderer.setAttribute(input,'type','text');
        this.renderer.setAttribute(input,'minlength','5');
        this.renderer.setAttribute(input,'maxlength','80');
        break;

      case 'puesto':
        this.renderer.setAttribute(input, 'id', 'inputPuestoId');
        this.renderer.setAttribute(input,'placeholder','Puesto solicitado')
        this.renderer.setAttribute(input,'type','text');
        this.renderer.setAttribute(input,'minlength','5');
        this.renderer.setAttribute(input,'maxlength','33');
        break;

      case 'tonelaje':
        this.renderer.setAttribute(input, 'id', 'inputTonelajeId');
        this.renderer.setAttribute(input,'placeholder','Toneladas')
        this.renderer.setAttribute(input,'type','number');
        this.renderer.setAttribute(input,'minlength','5');
        this.renderer.setAttribute(input,'maxlength','10');
        break;

      case 'm3':
        this.renderer.setAttribute(input, 'id', 'inputM3Id');
        this.renderer.setAttribute(input,'placeholder','m³')
        this.renderer.setAttribute(input,'type','number');
        this.renderer.setAttribute(input,'minlength','5');
        this.renderer.setAttribute(input,'maxlength','10');
        break;
    }

    this.renderer.appendChild(div,button)
    this.renderer.appendChild(button,input);

    return div;

  }

  async createInputFileElement(){

    let div = this.renderer.createElement('div');
    this.renderer.addClass(div, 'botonesRespuesta');
    this.renderer.setAttribute(div, 'id', 'FORMID');
    let parentDiv = this.renderer.createElement('div')
    this.renderer.addClass(parentDiv, 'parent-div');


    let button = this.renderer.createElement('button');
    this.renderer.addClass(button, 'btn-upload');

    let input = this.renderer.createElement('input');
    this.renderer.setAttribute(input,'type','file');
    this.renderer.setAttribute(input, 'id', 'inputFileId');
    this.renderer.setAttribute(input, 'accept', 'application/pdf');
    this.renderer.listen(input,'change', (event) =>{
      this.fileInputEvent(event)
      this.validateForm('file',event)
    })

    //this.renderer.appendChild(div,parentDiv);
    //this.renderer.appendChild(parentDiv,button);
    this.renderer.appendChild(div,input);



    return div;

  }

  async getFormData(type?:string){

    let htmlElement;
    let arrayData =[];
    console.log(type);
    if(type == 'confirm'){

      switch (this.INTENT) {
      case 'CM-mkt-comprar':

        htmlElement = document.getElementById('selectRegionId') as HTMLSelectElement;
        htmlElement?.options[htmlElement.selectedIndex].value == 'Estado/Región' ? this.estadoValue = 'N/A' : this.estadoValue = htmlElement?.options[htmlElement.selectedIndex].value;
        arrayData.push(this.estadoValue);

        htmlElement = document.getElementById('inputNombreId') as HTMLInputElement;
        htmlElement.value == '' ? this.nombreValue = 'N/A' : this.nombreValue = htmlElement.value;
        arrayData.push(this.nombreValue);

        htmlElement = document.getElementById('inputCorreoId') as HTMLInputElement;
        htmlElement.value == '' ? this.emailValue = 'N/A' : this.emailValue = htmlElement.value;
        arrayData.push(this.emailValue);

        htmlElement = document.getElementById('inputTelefonoId') as HTMLInputElement;
        htmlElement.value == '' ? this.telefonoValue = 'N/A' : this.telefonoValue = '(' + htmlElement.value.substring(0,3) + ')-' + htmlElement.value.substring(3,7) +'-'+htmlElement.value.substring(7,10);
        arrayData.push(this.telefonoValue);

        break;

      case 'CM-mkt-distribuidor':

        htmlElement = document.getElementById('selectRegionId') as HTMLSelectElement;
        htmlElement?.options[htmlElement.selectedIndex].value == 'Estado/Región' ? this.estadoValue = 'N/A' : this.estadoValue = htmlElement?.options[htmlElement.selectedIndex].value;
        arrayData.push(this.estadoValue);

        htmlElement = document.getElementById('inputNombreId') as HTMLInputElement;
        htmlElement.value == '' ? this.nombreValue = 'N/A' : this.nombreValue = htmlElement.value;
        arrayData.push(this.nombreValue);

        htmlElement = document.getElementById('inputCorreoId') as HTMLInputElement;
        htmlElement.value == '' ? this.emailValue = 'N/A' : this.emailValue = htmlElement.value;
        arrayData.push(this.emailValue);

        htmlElement = document.getElementById('inputTelefonoId') as HTMLInputElement;
        htmlElement.value == '' ? this.telefonoValue = 'N/A' : this.telefonoValue = '(' + htmlElement.value.substring(0,3) + ')-' + htmlElement.value.substring(3,7) +'-'+htmlElement.value.substring(7,10);
        arrayData.push(this.telefonoValue);

        break;

      case 'CM-mkt-asesoria':

        htmlElement = document.getElementById('inputNombreId') as HTMLInputElement;
        htmlElement.value == '' ? this.nombreValue = 'N/A' : this.nombreValue = htmlElement.value;
        arrayData.push(this.nombreValue);

        htmlElement = document.getElementById('inputCorreoId') as HTMLInputElement;
        htmlElement.value == '' ? this.emailValue = 'N/A' : this.emailValue = htmlElement.value;
        arrayData.push(this.emailValue);

        break;

      case 'CM-mkt-ofrecer':

        htmlElement = document.getElementById('selectRegionId') as HTMLSelectElement;
        htmlElement?.options[htmlElement.selectedIndex].value == 'Estado/Región' ? this.estadoValue = 'N/A' : this.estadoValue = htmlElement?.options[htmlElement.selectedIndex].value;
        arrayData.push(this.estadoValue);

        htmlElement = document.getElementById('inputNombreId') as HTMLInputElement;
        htmlElement.value == '' ? this.nombreValue = 'N/A' : this.nombreValue = htmlElement.value;
        arrayData.push(this.nombreValue);

        htmlElement = document.getElementById('inputCorreoId') as HTMLInputElement;
        htmlElement.value == '' ? this.emailValue = 'N/A' : this.emailValue = htmlElement.value;
        arrayData.push(this.emailValue);

        htmlElement = document.getElementById('inputTelefonoId') as HTMLInputElement;
        htmlElement.value == '' ? this.telefonoValue = 'N/A' : this.telefonoValue = '(' + htmlElement.value.substring(0,3) + ')-' + htmlElement.value.substring(3,7) +'-'+htmlElement.value.substring(7,10);
        arrayData.push(this.telefonoValue);

        htmlElement = document.getElementById('inputOfrecerId') as HTMLInputElement;
        htmlElement.value == '' ? this.ofrecerValue = 'N/A' : this.ofrecerValue = htmlElement.value;
        arrayData.push(this.ofrecerValue);

        break;

      case 'CM-mkt-stakeholder':

        htmlElement = document.getElementById('selectRegionId') as HTMLSelectElement;
        htmlElement?.options[htmlElement.selectedIndex].value == 'Estado/Región' ? this.estadoValue = 'N/A' : this.estadoValue = htmlElement?.options[htmlElement.selectedIndex].value;
        arrayData.push(this.estadoValue);

        htmlElement = document.getElementById('inputNombreId') as HTMLInputElement;
        htmlElement.value == '' ? this.nombreValue = 'N/A' : this.nombreValue = htmlElement.value;
        arrayData.push(this.nombreValue);

        htmlElement = document.getElementById('inputCorreoId') as HTMLInputElement;
        htmlElement.value == '' ? this.emailValue = 'N/A' : this.emailValue = htmlElement.value;
        arrayData.push(this.emailValue);

        htmlElement = document.getElementById('inputTelefonoId') as HTMLInputElement;
        htmlElement.value == '' ? this.telefonoValue = 'N/A' : this.telefonoValue = '(' + htmlElement.value.substring(0,3) + ')-' + htmlElement.value.substring(3,7) +'-'+htmlElement.value.substring(7,10);
        arrayData.push(this.telefonoValue);

        htmlElement = document.getElementById('inputStakeholderId') as HTMLInputElement;
        htmlElement.value == '' ? this.stakeholderValue = 'N/A' : this.stakeholderValue = htmlElement.value;
        arrayData.push(this.stakeholderValue);

        break;

      case 'CM-mkt-trabajar':

        htmlElement = document.getElementById('selectRegionId') as HTMLSelectElement;
        htmlElement?.options[htmlElement.selectedIndex].value == 'Estado/Región' ? this.estadoValue = 'N/A' : this.estadoValue = htmlElement?.options[htmlElement.selectedIndex].value;
        arrayData.push(this.estadoValue);

        htmlElement = document.getElementById('inputNombreId') as HTMLInputElement;
        htmlElement.value == '' ? this.nombreValue = 'N/A' : this.nombreValue = htmlElement.value;
        arrayData.push(this.nombreValue);

        htmlElement = document.getElementById('inputCorreoId') as HTMLInputElement;
        htmlElement.value == '' ? this.emailValue = 'N/A' : this.emailValue = htmlElement.value;
        arrayData.push(this.emailValue);

        htmlElement = document.getElementById('inputTelefonoId') as HTMLInputElement;
        htmlElement.value == '' ? this.telefonoValue = 'N/A' : this.telefonoValue = '(' + htmlElement.value.substring(0,3) + ')-' + htmlElement.value.substring(3,7) +'-'+htmlElement.value.substring(7,10);
        arrayData.push(this.telefonoValue);

        htmlElement = document.getElementById('inputPuestoId') as HTMLInputElement;
        htmlElement.value == '' ? this.puestoValue = 'N/A' : this.puestoValue = htmlElement.value;
        arrayData.push(this.puestoValue);

        //here file

        break;
      }

    }else if(type == 'tonelaje'){
      htmlElement = document.getElementById('inputTonelajeId') as HTMLInputElement;
      this.tonelajeValue = htmlElement.value;
      arrayData.push(this.tonelajeValue);

    }else if(type == 'm3'){
      htmlElement = document.getElementById('inputM3Id') as HTMLInputElement;
      this.m3Value = htmlElement.value;
      arrayData.push(this.m3Value);
    }
    console.log('ARRAY DATA IN GETFORM DATA')
    console.log(arrayData)

    return arrayData
  }

  async createConfirmStaticMessages(type?:string){
    if(type == 'confirm'){
      let formData = await this.getFormData(type);
      let txt;
      let br;
      this.CONFIRM_FORM_VALIDATOR = false;

      let MESSAGESelementArray = this.MESSAGES.nativeElement.children;
      console.log(MESSAGESelementArray);
      for (let i = 0; i < this.MESSAGES.nativeElement.children.length; i++) {
        if(MESSAGESelementArray[i].id == 'FORMID'){
          console.log(MESSAGESelementArray[i].children)
          if(MESSAGESelementArray[i].children[0].id == 'inputFileId'){
            this.renderer.removeChild(this.MESSAGES.nativeElement, this.MESSAGES.nativeElement.children[i])
          }else{
            this.renderer.setAttribute(this.MESSAGES.nativeElement.children[i].childNodes[0].childNodes[0],'disabled', 'true');
          }

        }

      }

        this.createStaticBotInteractionMessage('¿Los datos qué escribiste son correctos?');

        let _div = this.renderer.createElement('div');
        this.renderer.addClass(_div, 'question');
        let _uniqueImg = this.renderer.createElement('img');
        this.renderer.setProperty(_uniqueImg, 'src', this.LOGO_BOT);
        this.renderer.addClass(_uniqueImg, 'botMessage');
        this.renderer.setProperty(_uniqueImg, 'loading', 'lazy');
        this.renderer.appendChild(_div, _uniqueImg);

        for (let i = 0; i < formData.length; i++) {
          txt = this.renderer.createText(formData[i])
          this.renderer.appendChild(_div, txt);
          br = this.renderer.createElement('br')
          this.renderer.appendChild(_div, br);
        }

        this.renderer.appendChild(this.MESSAGES.nativeElement, _div);

      this.scrollDown();

      this.createButtons([{text:'Si', value:'si'},{text:'No', value:'no'}],'confirm');
    }else{
      this.CONFIRM_TONELAJE_VALIDATOR = false;
      this.CONFIRM_M3_VALIDATOR = false;
      let MESSAGESelementArray = this.MESSAGES.nativeElement.children;
      console.log(MESSAGESelementArray);
      for (let i = 0; i < this.MESSAGES.nativeElement.children.length; i++) {
        if(MESSAGESelementArray[i].id == 'FORMWEIGHTID'){
          console.log(MESSAGESelementArray[i])
          this.renderer.setAttribute(this.MESSAGES.nativeElement.children[i].childNodes[0].childNodes[0],'disabled', 'true');
        }

      }
      console.log(type)
      let formData = await this.getFormData(type);
      console.log(formData)
      this.createComponentsAnswerUser(formData[0],formData[0],type)
    }

  }

  createStaticBotInteractionMessage(text:string, concatString?:string){
    this.createHora();
    let _div = this.renderer.createElement('div');
    this.renderer.addClass(_div, 'question');
    let _uniqueImg = this.renderer.createElement('img');
    this.renderer.setProperty(_uniqueImg, 'src', this.LOGO_BOT);
    this.renderer.addClass(_uniqueImg, 'botMessage');
    this.renderer.setProperty(_uniqueImg, 'loading', 'lazy');

    let questionText:any;
    if(concatString){
      questionText = this.renderer.createText(text + ' "' +concatString+ '"?');
    }else{
      questionText = this.renderer.createText(text);
    }
    this.renderer.appendChild(_div, questionText);
    this.renderer.appendChild(_div, _uniqueImg);
    this.renderer.appendChild(this.MESSAGES.nativeElement, _div);
  }

  createSelectableButtons(Buttons: any[], type?:string): void {
    this.CONFIRM_SELECTABLE_BUTTON_VALIDATOR = true;

    let _div = this.renderer.createElement('div');
    this.renderer.addClass(_div, 'text-right-selectable');
    this.renderer.setAttribute(_div,'id','SELECTABLEDIV');
    Buttons.forEach((btn) => {
        const _button = this.renderer.createElement('button');
        this.renderer.addClass(_button, 'eliminar');
        const _buttonText = this.renderer.createText(btn.text);
        this.renderer.appendChild(_button, _buttonText);
        this.renderer.appendChild(_div, _button);
        this.renderer.setAttribute(_button,'id','SELECTABLEBUTTON');
        this.renderer.listen(_button, 'click', () => {
            if(!this.selectedButtonsArray.includes(btn.value)){
              this.selectButton(_button,btn.value);
            }else{
              this.deselectButton(_button,btn.value);
            }

        });
    });
    this.renderer.appendChild(this.MESSAGES.nativeElement, _div);
  }

  selectButton(buttonElement: any,buttonValue:string){
    console.log('seleccionao');
    this.renderer.removeClass(buttonElement,'eliminar');
    this.renderer.addClass(buttonElement,'invertedEliminar');

    this.selectedButtonsArray.push(buttonValue);
  }

  deselectButton(buttonElement: any,buttonValue:string){
    console.log('desSeleccionao');
    this.renderer.removeClass(buttonElement,'invertedEliminar');
    this.renderer.addClass(buttonElement,'eliminar');
    console.log(this.selectedButtonsArray.indexOf(buttonValue));
    this.selectedButtonsArray.splice(this.selectedButtonsArray.indexOf(buttonValue),1);
  }

  selectedProductsRoutine(){
    console.log(this.POR_ELIMINAR);

    let optionButtons = [{text:'Más de 500 toneladas',value:'Más de 500 toneladas'},{text:'Menos de 500 toneladas',value:'Menos de 500 toneladas'}];

    let selectableDivArray: any;
    this.CONFIRM_SELECTABLE_BUTTON_VALIDATOR = false;
    for (let i = 0; i < this.MESSAGES.nativeElement.children.length; i++) {
      if(this.MESSAGES.nativeElement.children[i].id == 'SELECTABLEDIV'){
        selectableDivArray = this.MESSAGES.nativeElement.children[i]
        for (let j = 0; j < selectableDivArray.children.length; j++) {
          if(selectableDivArray.children[j].className == 'eliminar'){
            this.renderer.removeChild(this.MESSAGES.nativeElement, this.MESSAGES.nativeElement.children[i].children[j])
          }
        }
        for (let j = 0; j < selectableDivArray.children.length; j++) {
          if(selectableDivArray.children[j].className == 'invertedEliminar'){
            this.renderer.setAttribute(this.MESSAGES.nativeElement.children[i].children[j],'disabled', 'true');
          }
        }
      }
    }

    this.stepperQuestion(0)

    console.log(this.selectedButtonsArray);
  }

  stepperQuestion(step: any){
    console.log(step)

    let optionButtons = [{text:'Más de 500 toneladas',value:'Más de 500 toneladas'},{text:'Menos de 500 toneladas',value:'Menos de 500 toneladas'}];

    console.log(this.POR_ELIMINAR)

    this.createStaticBotInteractionMessage('¿Cuál es el consumo que tiene de este producto ',this.selectedButtonsArray[step]);
      let _div = this.renderer.createElement('div');
      this.renderer.addClass(_div, 'text-right');
      optionButtons.forEach((btn) => {
        const _button = this.renderer.createElement('button');
        this.renderer.addClass(_button, 'eliminar');
        const _buttonText = this.renderer.createText(btn.text);
        this.renderer.appendChild(_button, _buttonText);
        this.renderer.appendChild(_div, _button);
        this.renderer.listen(_button, 'click', () => {

          this.createComponentAnswerStepper(`${btn.text}`, `${btn.value}`);

          this.POR_ELIMINAR += optionButtons.length;

        });
      });
      this.renderer.appendChild(this.MESSAGES.nativeElement, _div);
      this.scrollDown();
  }

  async createComponentAnswerStepper(Text: string, Answer: string,){

    this.removePlaceholderElements();
    this.creaRespuestaUsuario(Text);
    //this.createMessageGif();
    this.removePlaceholderDotsElements();

    this.selectedButtonsweightArray.push(Answer);

    if(this.STEPPER_VALIDATOR >= this.selectedButtonsArray.length-1){
      console.log('aqui merengo continuar')
      console.log(this.selectedButtonsArray);
      console.log(this.selectedButtonsweightArray);
      this.createComponentsAnswerUser('','','distribuidor')

    }else{
      this.STEPPER_VALIDATOR++;
      this.stepperQuestion(this.STEPPER_VALIDATOR);
    }


  }

  fileInputEvent(event:any){
    console.log(event)
    let files = event.target.files;
    if(files.length != 0){
      const file = event.target.files[0]
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.b64File = reader.result;
        this.b64FileName = file.name;
        console.log(this.b64FileName);
    };
    }else{
      console.log('aqui validar file')
    }
  }


  showImages(Padre: any, Images: any[]): void {
    let _imagesList: string[] = [];

    Images.forEach((img) => {
        _imagesList.push(img.imageUrl);
    });

    //Si la imagen es única.
    if (_imagesList.length === 1) {
        let _uniqueImg = this.renderer.createElement('img');
        this.renderer.setProperty(_uniqueImg, 'src', _imagesList[0]);
        this.renderer.addClass(_uniqueImg, 'uniqueImage');
        this.renderer.setProperty(_uniqueImg, 'loading', 'lazy');
        this.renderer.appendChild(Padre, _uniqueImg);
        let _hr = this.renderer.createElement('hr');
    } else {
        let _divSlides = this.renderer.createElement('div');
        this.renderer.addClass(_divSlides, 'w3-content');
        this.renderer.addClass(_divSlides, 'w3-display-container');
        _imagesList.forEach((_imgUrl) => {
            let _img = this.renderer.createElement('img');
            this.renderer.setProperty(_img, 'src', _imgUrl);
            this.renderer.addClass(_img, `mySlides`);
            this.renderer.addClass(_img, `mySlides${this.NUMBER_SLIDER}`);
            this.renderer.addClass(_img, 'fade');
            this.renderer.setProperty(_img, 'loading', 'lazy');
            this.renderer.appendChild(_divSlides, _img);
        });

        const _numberSlide: string = `mySlides${this.NUMBER_SLIDER}`;

        let _btnLeft = this.renderer.createElement('button');
        this.renderer.addClass(_btnLeft, 'w3-button');
        this.renderer.addClass(_btnLeft, 'w3-white');
        this.renderer.addClass(_btnLeft, 'w3-display-left');
        let _btnLeftImg = this.renderer.createElement('img');
        this.renderer.setProperty(_btnLeftImg, 'src', 'assets/icons/izquierda.svg');
        this.renderer.appendChild(_btnLeft, _btnLeftImg);
        this.renderer.listen(_btnLeft, 'click', () => {
            this.plusDivs(-1, _numberSlide);
        });

        let _btnRight = this.renderer.createElement('button');
        this.renderer.addClass(_btnRight, 'w3-button');
        this.renderer.addClass(_btnRight, 'w3-white');
        this.renderer.addClass(_btnRight, 'w3-display-right');
        let _btnRightImg = this.renderer.createElement('img');
        this.renderer.setProperty(_btnRightImg, 'src', 'assets/icons/derecha.svg');
        this.renderer.appendChild(_btnRight, _btnRightImg);
        this.renderer.listen(_btnRight, 'click', () => {
            this.plusDivs(1, _numberSlide);
        });

        this.renderer.appendChild(_divSlides, _btnLeft);
        this.renderer.appendChild(_divSlides, _btnRight);
        this.renderer.appendChild(Padre, _divSlides);
    }

    let _hr = this.renderer.createElement('hr');
    this.renderer.appendChild(Padre, _hr);
  }

  plusDivs(n: number, Slider: string): void {
    this.showDivs((this.SLIDE_INDEX += n), Slider);
  }

  validateForm(type:any,value:any){

    let emailPattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

    switch (type) {

      case 'estado':
        value != 'Estado/Región' ? this.estadoValidate = true : this.estadoValidate = false;
        console.log('estado',this.estadoValidate)
        break;

      case 'nombre':
        value.length > 0 ? this.nombreValidate = true : this.nombreValidate = false;
        console.log('nombre',this.nombreValidate)
        break;

      case 'correo':
        let lengthEmail;
        let patternEmail;
        value.length > 0 ? lengthEmail = true : lengthEmail = false;
        emailPattern.test(value) ? patternEmail = true : patternEmail = false;

        lengthEmail == true && patternEmail == true ? this.emailValidate = true : this.emailValidate = false;

        console.log('email',this.emailValidate)
        break;

      case 'telefono':
        value.length == 10 ? this.telefonoValidate = true : this.telefonoValidate = false;
        console.log('telefono',this.telefonoValidate)
        break;

      case 'ofrecer':
        value.length > 0 ? this.ofrecerValidate = true : this.ofrecerValidate = false;
        console.log('ofrecer',this.ofrecerValidate)
        break;

      case 'stakeholder':
        value.length > 0 ? this.stakeholderValidate = true : this.stakeholderValidate = false;
        console.log('stakeholder',this.stakeholderValidate)
        break;

      case 'puesto':
        value.length > 0 ? this.puestoValidate = true : this.puestoValidate = false;
        console.log('pueto',this.puestoValidate)
        break;

      case 'tonelaje':
        value.length > 0 ? this.tonelajeValidate = true : this.tonelajeValidate = false;
        console.log('tonelaje',this.tonelajeValidate)
        break;

      case 'm3':
        value.length > 0 ? this.m3Validate = true : this.m3Validate = false;
        console.log('m3',this.m3Validate)
        break;

      case 'file':
        let typeFile
        let existFile
        let sizeFile

        value.target.value.length > 0 ? existFile = true : existFile = false;
        if(value.target.files.length > 0){
          console.log('entra al if file length mayor 0')
          value.target.files[0].size <= 3145728 ? sizeFile = true : sizeFile = false;
          value.target.files[0].type == 'application/pdf' ? typeFile = true : typeFile = false;
        }else{
          sizeFile = false
        }

        console.log('existFile', existFile);
        console.log('sizefile', sizeFile);

        existFile == true && sizeFile == true && typeFile == true ? this.fileValidate = true : this.fileValidate = false;

        console.log('file',this.fileValidate)
        break;
    }

    this.allValidation();

  }

  allValidation(){

    switch (this.INTENT) {
      case 'CM-mkt-comprar':
        this.estadoValidate == true && this.nombreValidate == true && this.emailValidate == true && this.telefonoValidate == true ? this.FORM_VALIDATOR = true : this.FORM_VALIDATOR = false;
        break;

      case 'CM-mkt-distribuidor':
        this.estadoValidate == true && this.nombreValidate == true && this.emailValidate == true && this.telefonoValidate == true ? this.FORM_VALIDATOR = true : this.FORM_VALIDATOR = false;
        break;

      case 'CM-mkt-asesoria':
        this.nombreValidate == true && this.emailValidate == true ? this.FORM_VALIDATOR = true : this.FORM_VALIDATOR = false;
        break;

      case 'CM-mkt-ofrecer':
        this.estadoValidate == true && this.nombreValidate == true && this.emailValidate == true && this.telefonoValidate == true && this.ofrecerValidate == true ? this.FORM_VALIDATOR = true : this.FORM_VALIDATOR = false;
        break;

      case 'CM-mkt-stakeholder':
        this.estadoValidate == true && this.nombreValidate == true && this.emailValidate == true && this.telefonoValidate == true && this.stakeholderValidate == true ? this.FORM_VALIDATOR = true : this.FORM_VALIDATOR = false;
        break;

      case 'CM-mkt-trabajar':
        this.estadoValidate == true && this.nombreValidate == true && this.emailValidate == true && this.telefonoValidate == true && this.puestoValidate == true && this.fileValidate == true ? this.FORM_VALIDATOR = true : this.FORM_VALIDATOR = false;
        break;
      }
  }

  changeFormValidationStatus(_boolean: boolean){
    this.FORM_VALIDATOR = _boolean
    this.estadoValidate = _boolean
    this.nombreValidate = _boolean
    this.emailValidate  = _boolean
    this.telefonoValidate = _boolean
    this.fileValidate = _boolean
    this.ofrecerValidate = _boolean
    this.stakeholderValidate = _boolean
    this.puestoValidate = _boolean
  }
}
